module.exports = __webpack_public_path__ + "static/img/zhanwei.d4ab973.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/zhanwei.png
// module id = VQGZ
// module chunks = 1